const submenuVariants = {
  hidden: { height: 0, opacity: 0 },
  visible: {
    height: 'auto',
    opacity: 1,
    transition: {
      delay: 0.2,
      duration: 0.3,
      ease: 'easeInOut',
      when: 'beforeChildren',
      staggerChildren: 0.05, // Cada hijo se retrasa 50ms
    },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: { duration: 0.2, ease: 'easeInOut' },
  },
};

const submenuItemVariants = {
  hidden: { opacity: 0, y: -5 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.2, ease: 'easeOut' } },
};

const isDynamicRouteMatch = (
  pathname: string, 
  href: string, 
  excludedSubroutes: string[] = []
): boolean => {
  if (!pathname.startsWith(href)) return false;

  const restOfPath = pathname.slice(href.length);

  if (excludedSubroutes.includes(restOfPath)) return false;

  return /^\/[^/]+$/.test(restOfPath);
};

export {
  submenuVariants,
  submenuItemVariants,
  isDynamicRouteMatch,
};
